module.exports = __webpack_public_path__ + "assets/img/bg-female-004affca.png";